module.exports = __webpack_public_path__ + "static/media/cases_logos_institucionais_01.43d6f788.jpg";